import { create } from "zustand";

export type ToastTone = "info" | "success" | "warning" | "danger";

export interface ToastItem {
  id: string;
  title: string;
  description?: string;
  tone: ToastTone;
  duration: number;
  /** Optional button inside the toast (e.g. "Refresh"). */
  action?: { label: string; onClick: () => void };
}

interface ToastState {
  toasts: ToastItem[];
  push: (toast: Omit<ToastItem, "id" | "duration" | "tone"> & Partial<Pick<ToastItem, "tone" | "duration">>) => string;
  dismiss: (id: string) => void;
}

let counter = 0;

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (toast) => {
    const id = `t${++counter}`;
    const item: ToastItem = { tone: "info", duration: 5000, ...toast, id };
    set((s) => ({ toasts: [...s.toasts.slice(-4), item] }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Imperative helper usable outside React components. */
export const toast = {
  info: (title: string, description?: string) => useToasts.getState().push({ title, description, tone: "info" }),
  success: (title: string, description?: string) => useToasts.getState().push({ title, description, tone: "success" }),
  warning: (title: string, description?: string) => useToasts.getState().push({ title, description, tone: "warning" }),
  error: (title: string, description?: string) => useToasts.getState().push({ title, description, tone: "danger", duration: 7000 }),
};
